<template>
<CityBackgroundImage :add-header="true" :showGoToListButton="true">
  <v-layout justify-center row fill-height class="edit-project-page">
    <v-flex xs12 md10 xl8>
      <v-card>
        <v-card-title>
          <div class="asu-title">Editar proyecto</div>
        </v-card-title>
        <v-card-text>

          <v-tabs :value="activeTab" icons-and-text ref="tabsContainer" slider-color="primary" @change="$emit('change-tab', $event)" >
            <v-tab href="#general">Descripción <i class="ap-description"></i></v-tab>
            <v-tab-item value="general">
              <div class="tab-content tab_1">

                <GeneralForm
                  :code="project.code"
                  :isCreateView="isCreateView"
                  v-model="project.general"
                  :customValidations="validations.general"
                  :buttonNextPressed="buttonNextPressedIn['general']"
                  @on-save-press="onValid($event)"
                  @on-change-files="onChangeFiles({ $event, tab: 'general' })"
                  @on-change-tab-height="onChangeTabHeight"
                />

              </div>
            </v-tab-item>

            <v-tab href="#fichaTecnica" :disabled="isCreateView && indexTab < 1">Ficha Técnica <i class="ap-data-sheet"></i></v-tab>
            <v-tab-item value="fichaTecnica">
              <div class="tab-content tab_2" v-show="!isCreateView || indexTab === 1">

                <FichaTecnicaForm
                  :code="project.code"
                  :isCreateView="isCreateView"
                  v-model="project.fichaTecnica"
                  :customValidations="validations.fichaTecnica"
                  :buttonNextPressed="buttonNextPressedIn['fichaTecnica']"
                  @on-save-press="onValid($event)"
                  @on-change-files="onChangeFiles({ $event, tab: 'fichaTecnica' })"
                  @on-change-tab-height="onChangeTabHeight"
                />

              </div>
            </v-tab-item>

            <v-tab href="#estadisticas" :disabled="isCreateView && indexTab < 2">Estadísticas <i class="ap-statistic"></i></v-tab>
            <v-tab-item value="estadisticas">
              <div class="tab-content tab_3" v-show="!isCreateView || indexTab === 2">

                <EstadisticasForm
                  :code="project.code"
                  :isCreateView="isCreateView"
                  v-model="project.estadisticas"
                  :customValidations="validations.estadisticas"
                  :buttonNextPressed="buttonNextPressedIn['estadisticas']"
                  @on-save-press="onValid($event)"
                  @on-change-files="onChangeFiles({ $event, tab: 'estadisticas' })"
                  @on-change-tab-height="onChangeTabHeight"
                />

              </div>
            </v-tab-item>

            <v-tab href="#documentos" :disabled="isCreateView && indexTab < 3">Documentos <i class="ap-download"></i></v-tab>
            <v-tab-item value="documentos">
              <div class="tab-content tab_4" v-show="!isCreateView || indexTab === 3">

                <DocumentoForm
                  :code="project.code"
                  :isCreateView="isCreateView"
                  v-model="project.documentos"
                  :customValidations="validations.documentos"
                  :buttonNextPressed="buttonNextPressedIn['documentos']"
                  @on-save-press="onValid($event)"
                  @on-change-files="onChangeFiles({ $event, tab: 'documentos' })"
                  @on-change-tab-height="onChangeTabHeight"
                />

              </div>
            </v-tab-item>

            <v-tab href="#componentes" :disabled="isCreateView && indexTab < 4">Sub-proyectos <i class="ap-subproject"></i></v-tab>
            <v-tab-item value="componentes">
              <div class="tab-content tab_5" v-show="!isCreateView || indexTab === 4">

                <SubprojectoForm
                  :code="project.code"
                  :isCreateView="isCreateView"
                  v-model="project.componentes"
                  :customValidations="validations.componentes"
                  :buttonNextPressed="buttonNextPressedIn['componentes']"
                  @on-save-press="onValid($event)"
                  @on-change-files="onChangeFiles({ $event, tab: 'componentes' })"
                  @on-change-tab-height="onChangeTabHeight"
                />

              </div>
            </v-tab-item>

            <v-tab :href="`#${lastTab}`" :disabled="isCreateView && indexTab < 5">Vista Satelital <i class="ap-subproject"></i></v-tab>
            <v-tab-item :value="lastTab">
              <div class="tab-content tab_6" v-show="!isCreateView || indexTab === 5">

                <VistaSatelitalForm
                  :code="project.code"
                  :isCreateView="isCreateView"
                  v-model="project.vistaSatelital"
                  :customValidations="validations.vistaSatelital"
                  :buttonNextPressed="buttonNextPressedIn['vistaSatelital']"
                  @on-save-press="onValid($event)"
                  @on-change-files="onChangeFiles({ $event, tab: 'vistaSatelital' })"
                  @on-change-tab-height="onChangeTabHeight"
                />

              </div>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
        <v-card-actions>
          <v-layout align-center justify-end>
            <v-btn @click="$emit('go-to-tab', -1)" v-if="!!indexTab">Atras</v-btn>
            <v-btn @click="goToNext()" v-if="(indexTab + 1) < amountOfTabs">Siguiente</v-btn>
            <v-btn dark color="primary" @click="goToNext()" v-if="(indexTab + 1) >= amountOfTabs && isCreateView">Guardar</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
  <custom-dialog-confirm
    :active="successDialog"
    title="Proyecto guardado"
    :content="`El proyecto ${projectSaved.name} con número ${projectSaved.number} ${isCreateView ? 'ha sido modificado y ':''}guardado correctamente`"
    confirm-text="Aceptar"
    @confirm="$emit('confirm-success-dialog', $event)" />
</CityBackgroundImage>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { clone, hasValue } from '@/utils/object.js'

const lastTab = 'vistaSatelital'

export const tabList = [
  'general',
  'fichaTecnica',
  'estadisticas',
  'documentos',
  'componentes',
  lastTab
]

const buttonNextPressedInitialObject = tabList.reduce((obj, key) => ({ ...obj, [key]: false }), {})

export default {
  components: {
    GeneralForm: _ => import('@/components/ProjectForm/GeneralForm'),
    FichaTecnicaForm: _ => import('@/components/ProjectForm/FichaTecnicaForm'),
    EstadisticasForm: _ => import('@/components/ProjectForm/EstadisticasForm'),
    DocumentoForm: _ => import('@/components/ProjectForm/DocumentoForm'),
    SubprojectoForm: _ => import('@/components/ProjectForm/SubprojectoForm'),
    VistaSatelitalForm: _ => import('@/components/ProjectForm/VistaSatelitalForm')
  },
  props: {
    indexTab: {
      type: Number,
      default: 0
    },
    activeTab: {
      type: String,
      default: 'general'
    },
    project: {
      type: Object,
      default: () => null
    },
    projectSaved: {
      type: Object,
      default: () => ({})
    },
    isCreateView: {
      type: Boolean,
      default: false
    },
    successDialog: {
      type: Boolean,
      default: false
    },
    validations: {
      type: Object,
      default: () => ({})
    }
  },
  mounted () {
    if (!(this.apiKey)) return this.redirectToLogin()
    this.loadFilesObject()
  },
  data: () => ({
    lastTab,
    amountOfTabs: tabList.length,
    files: {},
    buttonNextPressedIn: clone(buttonNextPressedInitialObject)
  }),
  methods: {
    ...mapActions([ 'redirectToLogin' ]),
    onValid (event) {
      this.$emit('on-save-press', event)
    },
    loadFilesObject () {
      if (hasValue(this.files)) tabList.forEach(key => { this.files[key] = {} })
    },
    onChangeFiles ({ $event, tab }) {
      this.files = { ...this.files, [tab]: $event }
      this.$emit('on-change-files', this.files)
    },
    onChangeTabHeight (event) {
      if (this.$refs.tabsContainer) { this.$refs.tabsContainer.$children[0].$el.removeAttribute('style') }
    },
    goToNext () {
      if (this.isCreateView) {
        const self = this
        setTimeout(() => { self.buttonNextPressedIn = clone(buttonNextPressedInitialObject) })
        setTimeout(() => { self.buttonNextPressedIn[tabList[self.indexTab]] = true })
      } else this.$emit('go-to-tab', +1)
    }
  },
  computed: {
    ...mapGetters([ 'apiKey' ])
  }
}
</script>
<style scoped lang="stylus">
@import '~@/styles/edit-project-form-style'
</style>
